import React from 'react';
import { LoadingStore } from '../../store/LoadingStore';
// import { LoadingStore } from '@store';

export default function GlobalHeavyLoading() {
  const heavy = LoadingStore((s) => s.heavy);
//   console.log('[UI] heavy state =', heavy);
  if (!heavy) return null;

  return (
    <div style={{
      position: 'fixed', inset: 0, zIndex: 9999,
      display: 'flex', alignItems: 'center', justifyContent: 'center',
      background: 'rgba(0,0,0,0.25)',
    }}>
      <div style={{
        width: 60, height: 60, border: '6px solid #fff',
        borderTopColor: 'transparent', borderRadius: '50%',
        animation: 'spin 0.8s linear infinite',
      }} />
      <style>{`@keyframes spin{to{transform:rotate(360deg)}}`}</style>
    </div>
  );
}
